import axios from 'axios'

// import { BASE_API_URL } from '../constants'
const BASE_API_URL =
  window.location.origin.includes('localhost') || window.location.origin.includes('127.0.0.1')
    ? 'https://127.0.0.1:5001/api'
    : `${window.location.origin}/api`

const ONE_SECOND = 1000

export const customAxios = axios.create({
  baseURL: BASE_API_URL,
  timeout: ONE_SECOND * 30,
  headers: {
    'Content-Type': 'application/json'
    // 'Content-Type': 'multipart/form-data'
  }
})
